<template>
  <div class="fullscreen-bg" v-fullscreen="fullscreen">
    <div class="RecyclingOutlets-head">
      <div class="RecyclingOutlets-head-weather headContent">
        <div
          @click="goBack"
          class="RecyclingOutlets-head-weather-back parallelogram"
        >
          <img src="~@/assets/recycling/index/back-btn.png" alt="" />
        </div>
        <div class="RecyclingOutlets-head-weather-time">
          <img
            class="dateImg"
            :title="todayWeather.dayweather"
            :src="weatherImg[todayWeather.dayweather]"
            alt="天气预报"
          />
          <div class="timeDate">
            <div class="timeDate_top">{{ time }}</div>
            <div class="timeDate_btn">
              {{ todayWeather.city }}
              <span
                >{{ todayWeather.nighttemp }}℃-{{ todayWeather.daytemp }}℃</span
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="RecyclingOutlets-head-title headContent"
        :class="title.length > 18 ? 'changeTitleSize' : ''"
      >
        {{ title }}
      </div>
      <div class="RecyclingOutlets-head-action headContent">
        <div
          v-if="!fullscreen"
          class="parallelogram RecyclingOutlets-head-action-search RecyclingOutlets-head-action-area-flex"
        >
          <!-- <div class="content" @click="screen">全屏</div> -->
          <img
            src="~@/assets/recycling/index/fullscreen.png"
            alt=""
            @click="screen"
          />
        </div>
        <div
          v-else
          class="parallelogram RecyclingOutlets-head-action-search RecyclingOutlets-head-action-area-flex"
        >
          <!-- <div class="content" @click="screen">退出全屏</div> -->
          <img
            src="~@/assets/recycling/index/fullscreen.png"
            alt=""
            @click="screen"
          />
        </div>
      </div>
    </div>
    <div class="image-content">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="image-wrapper"
        :class="'img-' + (index + 1)"
        @click="jumpToDetail(image.path)"
      >
        <img :src="image.normal" class="normal-image" />
        <img :src="image.hover" class="hover-image" />
      </div>
    </div>
  </div>
</template>
  
<script>
import { DateFormat } from '@/util/dateFormat';
import axios from 'axios';
export default {
  data() {
    return {
      images: [
        {
          path: '/largeScreen',
          normal: require('@/assets/recycling/index/btn4.png'),
          hover: require('@/assets/recycling/index/btn4-checked.png'),
        },
        {
          path: '/managementPage',
          normal: require('@/assets/recycling/index/btn3.png'),
          hover: require('@/assets/recycling/index/btn3-checked.png'),
        },
        {
          path: '/empty',
          normal: require('@/assets/recycling/index/btn1.png'),
          hover: require('@/assets/recycling/index/btn1-checked.png'),
        },
        {
          path: '/empty',
          normal: require('@/assets/recycling/index/btn2.png'),
          hover: require('@/assets/recycling/index/btn2-checked.png'),
        },
      ],
      title: '再生资源全流程溯源平台',
      fullscreen: false,
      todayWeather: {
        daytemp: '',
        nighttemp: '',
        dayweather: '',
        city: '',
      },
      time: '',
      mapTimer: '',
      weatherImg: {
        多云: require('@/assets/recycling/weatherImg/多云.svg'),
        晴: require('@/assets/recycling/weatherImg/晴.svg'),
        阴: require('@/assets/recycling/weatherImg/阴天.svg'),
        阵雨: require('@/assets/recycling/weatherImg/阵雨.svg'),
        雷阵雨: require('@/assets/recycling/weatherImg/雷阵雨.svg'),
        雷阵雨伴有冰雹: require('@/assets/recycling/weatherImg/雷阵雨伴有冰雹.svg'),
        雨夹雪: require('@/assets/recycling/weatherImg/雨夹雪.svg'),
        小雨: require('@/assets/recycling/weatherImg/小雨.svg'),
        中雨: require('@/assets/recycling/weatherImg/中雨.svg'),
        大雨: require('@/assets/recycling/weatherImg/大雨.svg'),
        暴雨: require('@/assets/recycling/weatherImg/暴雨.svg'),
        大暴雨: require('@/assets/recycling/weatherImg/大暴雨.svg'),
        特大暴雨: require('@/assets/recycling/weatherImg/特大暴雨.svg'),
        阵雪: require('@/assets/recycling/weatherImg/阵雨.svg'),
        小雪: require('@/assets/recycling/weatherImg/小雪.svg'),
        中雪: require('@/assets/recycling/weatherImg/中雪.svg'),
        大雪: require('@/assets/recycling/weatherImg/大雪.svg'),
        暴雪: require('@/assets/recycling/weatherImg/暴雪.svg'),
        雾: require('@/assets/recycling/weatherImg/雾.svg'),
        冻雨: require('@/assets/recycling/weatherImg/冻雨.svg'),
        沙尘暴: require('@/assets/recycling/weatherImg/沙尘暴.svg'),
        小雨转中雨: require('@/assets/recycling/weatherImg/小雨转中雨.svg'),
        中雨转大雨: require('@/assets/recycling/weatherImg/中雨转大雨.svg'),
        大雨转暴雨: require('@/assets/recycling/weatherImg/大雨转暴雨.svg'),
        暴雨转大暴雨: require('@/assets/recycling/weatherImg/暴雨转大暴雨.svg'),
        大暴雨转特大暴雨: require('@/assets/recycling/weatherImg/大暴雨转特大暴雨.svg'),
        小雪转中雪: require('@/assets/recycling/weatherImg/小雪转中雪.svg'),
        中雪转大雪: require('@/assets/recycling/weatherImg/中雪转大雪.svg'),
        大雪转暴雪: require('@/assets/recycling/weatherImg/大雪转暴雪.svg'),
        浮尘: require('@/assets/recycling/weatherImg/浮尘.svg'),
        扬沙: require('@/assets/recycling/weatherImg/扬沙-右下.svg'),
        强沙尘暴: require('@/assets/recycling/weatherImg/强沙尘暴.svg'),
        霾: require('@/assets/recycling/weatherImg/霾.svg'),
      },
    };
  },
  directives: {
    fullscreen: {
      inserted(el, binding) {
        if (binding.value) {
          el.requestFullscreen?.();
        } else {
          if (document.fullscreenElement) {
            document?.exitFullscreen?.();
          }
        }
      },
      update(el, binding) {
        if (binding.value && !document.fullscreenElement) {
          el.requestFullscreen?.();
        } else if (!binding.value && document.fullscreenElement) {
          document.exitFullscreen?.();
        }
      },
    },
  },
  mounted() {
    // 初始化数据
    this.getTime();
    this.getWeather();
    this.updateTimeAndWeather();
    // 监听全屏变化事件
    document.addEventListener('fullscreenchange', () => {
      this.fullscreen = !!document.fullscreenElement;
    });
  },
  methods: {
    getTime() {
      this.time = DateFormat(new Date(), 'yyyy-MM-dd W');
      this.$store.state.echartsMap.timeHistory = this.time;
    },
    screen() {
      this.fullscreen = !this.fullscreen;
    },
    // 0点更新时间和天气
    updateTimeAndWeather() {
      clearInterval(this.mapTimer);
      this.mapTimer = setInterval(() => {
        const time = DateFormat(new Date(), 'yyyy-MM-dd W');
        if (time !== this.$store.state.echartsMap.timeHistory) {
          this.getTime();
          this.getWeather();
        }
      }, 1000);
    },
    getWeather() {
      axios
        .get('https://restapi.amap.com/v3/weather/weatherInfo', {
          params: {
            key: '8ce1786d87100ab8f6658c3404ecd3f9',
            city: 510100,
            extensions: 'all', // base:返回实况天气 all:返回预报天气
          },
        })
        .then((res) => {
          console.log(res.data, 'resresresres');
          this.todayWeather.daytemp = res.data.forecasts[0].casts[0].daytemp;
          this.todayWeather.nighttemp =
            res.data.forecasts[0].casts[0].nighttemp;
          this.todayWeather.dayweather =
            res.data.forecasts[0].casts[0].dayweather;
          this.todayWeather.city = res.data.forecasts[0].city;
        });
    },
    jumpToDetail(value) {
      if (!value) {
        return false;
      }
      this.$router.push(value);
    },
    goBack() {
      if (this.$router) {
        this.$router.go(-1);
      } else {
        window.history.back();
      }
    },
  },
  destroyed() {
    clearInterval(this.mapTimer);
  },
};
</script>
  
<style lang="less" scoped>
.fullscreen-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/recycling/index/whole-process.png');
  background-size: 100% 100%; /* 改为100%宽度和高度，实现拉伸效果 */
  background-position: center center;
  background-repeat: no-repeat;
}

.RecyclingOutlets-head {
  height: 88px;
  width: 100%;
  display: flex;
  align-items: center;
  .headContent {
    flex: 1;
  }
  .RecyclingOutlets-head-title {
    display: flex;
    font-weight: 700;
    align-items: center;
    font-size: 32px;
    color: #ffffff;
    justify-content: center;
    padding-bottom: 25px;
  }
  .RecyclingOutlets-head-weather {
    padding-left: 62px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    padding-top: 1%;
    box-sizing: border-box;
    .RecyclingOutlets-head-weather-back {
      width: 79px;
      height: 32px;
      font-weight: 700;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
    }
    .RecyclingOutlets-head-weather-time {
      margin-left: 20px;
      font-size: 14px;
      height: 43px;
      width: 215px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      .dateImg {
        width: 40px;
        height: 40px;
      }
      .timeDate {
        font-size: 14px;
        margin-left: 10px;
        color: #cce7ff;
        .timeDate_top {
          font-weight: 500;
        }
        .timeDate_btn {
          font-weight: 500;
          span {
            font-size: 14px;
            color: #27fffc;
          }
        }
      }
    }
  }
  .RecyclingOutlets-head-action {
    padding-top: 1%;
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;
    padding-right: 62px;
    .RecyclingOutlets-head-action-area {
      display: flex;
    }
    .RecyclingOutlets-head-action-search {
      width: 59px;
      height: 32px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.image-content {
  margin: 270px auto 0;
  width: 1500px;
  height: 357px;
  display: grid;
  grid-template-areas:
    'top-left top-right'
    'bottom-left bottom-right';
  .img-1 {
    grid-area: top-left;
    align-self: start;
    justify-self: start;
  }

  .img-2 {
    grid-area: top-right;
    align-self: start;
    justify-self: end;
  }

  .img-3 {
    grid-area: bottom-left;
    align-self: end;
    justify-self: start;
  }

  .img-4 {
    grid-area: bottom-right;
    align-self: end;
    justify-self: end;
  }
}

.image-wrapper {
  width: 384px;
  height: 120px;
}

.normal-image,
.hover-image {
  position: absolute;
  width: 384px;
  height: 120px;
  transition: opacity 0.3s;
}

.hover-image {
  opacity: 0;
}

.image-wrapper:hover .normal-image {
  opacity: 0;
}

.image-wrapper:hover .hover-image {
  opacity: 1;
}
</style>